import { IotError } from "@core/domain/errors/iot.error.ts";
import * as z from "zod";
import i18n from "../../../../i18n";

const brandSchema = z.literal("FallbackError").brand<"FallbackError">();

export class FallbackError extends IotError {
    readonly _brand = brandSchema;

    constructor() {
        super(i18n.t("error:core.fallbackErrorMessage"));

        Object.setPrototypeOf(this, FallbackError.prototype);
    }
}
